export enum SubscriptionType {
  FREE = 'free',
  PERSONAL = 'personal',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
}

export enum ExtendedSubscriptionType {
  PERSONAL_DISTRIBUTION = 'personal_distribution',
  PRO_DISTRIBUTION = 'pro_distribution',
}
